import React, { FC, useState, useEffect } from "react";
import * as M from "moment";
import styles from "../styles.module.scss";
import Constants from "../../../constants/Common";
import dictionaryStore from "../../../store/dictionary";
import { observer } from "mobx-react";

interface IAttributesHistoryProps {
  dictionaryId: number
}

const AttributesHistory: FC<IAttributesHistoryProps> = observer(({dictionaryId}) => {
  useEffect(() => {
    dictionaryStore.getDictinaryHistory(dictionaryId);
    return () => {
      dictionaryStore.dictHistory = [];
    }
  }, [])

  return (
    <table className={styles.attributesHistory__table}>
      <thead>
        <tr className={styles.attributesHistory__tableGroupHead}>
            <th>Дата изменения</th>
            <th>Пользователь</th>
            <th>Поле</th>
            <th>Старое значение</th>
            <th>Новое значение</th>
        </tr>
      </thead>
      <tbody>
        {dictionaryStore.dictHistory.length > 0 
          ? 
          dictionaryStore.dictHistory.map((item, idx) => {
             return (
              <tr className={styles.attributesHistory__tableGroupTbody} key={idx}>
                <td>
                  {item.modifiedDateTime ? M(item.modifiedDateTime).format(Constants.dateTimeFormat) : Constants.notSet}
                </td>
                <td>
                  {item.modifiedBy}
                </td>
                <td>
                  {item.key}
                </td>
                <td>
                  {item.oldValue ? item.oldValue : "-"}
                </td>
                <td>
                  {item.newValue}
                </td>
              </tr>
            )
          })
        : 
          <tr>
            <th className={styles.attributesHistory__warning}>Нет данных</th>
          </tr>
       }  
      </tbody>
    </table>
  );
});

export default AttributesHistory;